import versions from '../../../../server/rapa/common/legal_versions.json'
import termsEn from './terms.en.md?raw'
import termsEs from './terms.es.md?raw'
import privacyEn from './privacy.en.md?raw'
import privacyEs from './privacy.es.md?raw'
import guestCoEn from './guest-privacy.co.en.md?raw'
import guestCoEs from './guest-privacy.co.es.md?raw'
import guestGenericEn from './guest-privacy.generic.en.md?raw'
import guestGenericEs from './guest-privacy.generic.es.md?raw'

export type LegalDocKey = 'terms' | 'privacy' | 'guest-privacy'
export type LegalLanguage = 'en' | 'es'

type VersionInfo = { version: string; effectiveDate: string }

// Version ids live in server/rapa/common/legal_versions.json so the server can
// validate submitted consent versions against the same source.
export const legalVersions = versions as {
  terms: VersionInfo
  privacy: VersionInfo
  guestPrivacy: Record<'CO' | 'generic', VersionInfo>
}

const bodies = {
  terms: { en: termsEn, es: termsEs },
  privacy: { en: privacyEn, es: privacyEs },
  guestPrivacy: {
    CO: { en: guestCoEn, es: guestCoEs },
    generic: { en: guestGenericEn, es: guestGenericEs },
  },
}

export const isLegalDocKey = (key: string | undefined): key is LegalDocKey =>
  key === 'terms' || key === 'privacy' || key === 'guest-privacy'

// Unknown or missing country falls back to the generic guest notice.
export const resolveGuestPrivacyVariant = (country?: string | null): 'CO' | 'generic' =>
  country?.toUpperCase() === 'CO' ? 'CO' : 'generic'

export const getLegalDocument = (
  doc: LegalDocKey,
  language: string,
  country?: string | null,
): VersionInfo & { body: string } => {
  const lang: LegalLanguage = language === 'es' ? 'es' : 'en'
  if (doc === 'guest-privacy') {
    const variant = resolveGuestPrivacyVariant(country)
    return { ...legalVersions.guestPrivacy[variant], body: bodies.guestPrivacy[variant][lang] }
  }
  return { ...legalVersions[doc], body: bodies[doc][lang] }
}
